import React, { Component, Fragment } from "react";
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import {
  Container,
  Row,
  Col,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";
import { connect } from "react-redux";
import { getUser } from "../redux/actions/userActions";
import { getVouchers } from "../redux/actions/voucherActions";
import {
  addGameToCard,
  boughtFinish,
  fetchGames,
  removeGameFromCard,
  removeGameFromUserFav,
} from "../redux/actions/gameActions";
import moment from "moment";
import { removeFavorite } from "../redux/actions/favActions";

export class FavoriteGames extends Component {
  componentDidMount() {
    this.props.fetchGames();
    setTimeout(() => {
      this.props.boughtFinish();
    }, 5000);
    this.props.getVouchers();
    let user = JSON.parse(localStorage.getItem("user_info"));
    this.props.getUser(user.id);
    console.log(user, this.props.getUser);
  }
  isItemInCart = (id) => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) {
      let exist = cart.find((item) => item == id);
      if (exist) return true;
    }
    return false;
  };
  getMyGames = () => {
    let myGames = null;
    let { game } = this.props;
    let user = JSON.parse(localStorage.getItem("user_info"));
    if (game.games != null && user != null) {
      myGames = [];
      let { my_games } = user;
      for (let mGame of my_games) {
        console.log(mGame);
        let obj =
          game.games != -1 && game.games.find((game) => game.id == mGame);
        if (obj != null && obj != false) myGames.push(obj);
      }
    }
    return myGames;
  };
  render() {
    var { vouchers, games, user, bought } = this.props;

    return (
      <Fragment>
        <Header {...this.props} heading="My Favorite Games" />
        <Container className="bg-dark-1 margin-top-fix fav-games-container mb-5">
          {games &&
            user &&
            user.my_games &&
            games.length &&
            games
              .filter((game) => user.my_favourites.includes(game.id))
              .map((game) => {
                return (
                  <>
                    <Row className="justify-content-center align-items-end ">
                      <Col xl={4} lg={4} md={10} sm={12}>
                        <div
                          className="fav-game-img fav-game-img-1"
                          style={{ backgroundImage: `url(${game.img})` }}
                        ></div>
                      </Col>
                      <Col lg={8} md={10} xs={11}>
                        <div className="d-flex text-white-1 mt-3 mt-lg-0">
                          <CardTitle tag="h5">{game.title}</CardTitle>
                          <div className="ms-auto">
                            <CardSubtitle>Price</CardSubtitle>
                          </div>
                        </div>
                        <Row className="justify-content-between text-white-1 mt-3">
                          <Col xs={3}>
                            <div className="text-start">
                              <CardSubtitle className="">
                                {game.city}
                              </CardSubtitle>
                            </div>
                          </Col>
                          <Col lg={3} sm={4} xs={5}>
                            <div className="text-center">
                              <CardSubtitle className="text-muted ">
                                {moment(game.start_date.toDate()).format(
                                  "DD MMM YYYY"
                                )}{" "}
                              </CardSubtitle>
                            </div>
                          </Col>
                          <Col xs={3}>
                            <div className="text-end">
                              <CardSubtitle className="text-green-1">
                                {game.price} $
                              </CardSubtitle>
                            </div>
                          </Col>
                        </Row>
                        <Col lg={8}>
                          <CardSubtitle
                            tag="h6"
                            className="mb-2 text-muted mt-3"
                            style={{ lineHeight: 1.5 }}
                          >
                            About : {game.case_incident}
                          </CardSubtitle>
                        </Col>
                        <Row className="justify-content-between align-items-end">
                          <Col xl={4} lg={5} sm={6} xs={7}>
                            <Button
                              className="bg-purple-1 w-100 text-white-1 mt-5 px-4 py-3"
                              style={{ borderRadius: 10, border: "none" }}
                              onClick={(e) => {
                                this.isItemInCart(game.id)
                                  ? this.props.removeGameFromCart(game.id)
                                  : this.props.addGameToCart(game.id);
                              }}
                            >
                              {this.isItemInCart(game.id) ? null : (
                                <i className="fas fa-cart-plus px-2"></i>
                              )}
                              <span className="px-2">
                                {this.isItemInCart(game.id)
                                  ? "Remove"
                                  : "Join Now"}
                              </span>
                            </Button>
                          </Col>
                          <Col lg={3} sm={4} xs={5}>
                            <div className="text-end">
                              <Button
                                className="btn-font bg-purple-2 text-yellow-2 mt-5 mt-xl-0 px-3 ms-auto"
                                style={{
                                  borderRadius: 10,
                                  border: "1px solid #FFC144",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.props.removeGameFromUserFav(game.id);
                                  this.props.removeFavorite(user.id, game.id);
                                }}
                              >
                                <span className="px-1">Remove</span>
                                <i
                                  className="fas fa-heart text-red-1"
                                  // style={{ fontSize: 30 }}
                                ></i>
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <hr
                      className="text-purple-1 mt-5 mx-3 mx-sm-0"
                      style={{ height: 3 }}
                    />
                  </>
                );
              })}
        </Container>
        <Footer />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    game: state.game,
    user: state.auth.user,
    bought: state.game.bought,
    games: state.game.games,
    vouchers: state.voucher.vouchers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchGames: () => dispatch(fetchGames()),
    boughtFinish: () => dispatch(boughtFinish()),
    getVouchers: () => dispatch(getVouchers()),
    getUser: (uid) => dispatch(getUser(uid)),
    removeFavorite: (uid, id) => dispatch(removeFavorite(uid, id)),
    addGameToCart: (id) => dispatch(addGameToCard(id)),
    removeGameFromCart: (id) => dispatch(removeGameFromCard(id)),
    removeGameFromUserFav: (id) => dispatch(removeGameFromUserFav(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FavoriteGames);
